module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col bg-white border rounded p-5 h-full"
  }, [_c('div', {
    staticClass: "flex-grow"
  }, [_c('div', {
    staticClass: "font-bold text-2xl"
  }, [_vm._v(_vm._s(_vm.infoCard.title))]), _vm._v(" "), _c('div', {
    staticClass: "my-5 flex items-center relative"
  }, [((_vm.index === 0 || _vm.index === 1 || _vm.index === 2) && _vm.free_teacher_account) ? _c('div', {
    staticClass: "absolute top-2 left-2.5 px-7 py-2 bg-white text-green-700 z-10 border-2 border-green-700 rounded font-semibold"
  }, [_vm._v("\n        Upgrade "), _c('br'), _vm._v("Required\n      ")]) : _vm._e(), _vm._v(" "), (_vm.index === 0 || _vm.index === 1 || _vm.index === 2) ? _c('img', {
    staticClass: "w-36 h-20",
    class: [_vm.free_teacher_account ? 'opacity-50' : ''],
    attrs: {
      "src": _vm.infoCard.image
    }
  }) : _c('img', {
    staticClass: "h-20 w-20",
    attrs: {
      "src": _vm.infoCard.image
    }
  }), _vm._v(" "), _c('div', {
    class: [_vm.index === 2 ? 'ml-7' : 'ml-5']
  }, [_vm._v("\n        " + _vm._s(_vm.infoCard.description) + "\n      ")])])]), _vm._v(" "), _c('button', {
    staticClass: "w-full py-2 px-4 bg-primary hover:bg-primary-dark text-white uppercase rounded relative disabled:opacity-50",
    attrs: {
      "disabled": (_vm.index === 0 || _vm.index === 1 || _vm.index === 2) && _vm.free_teacher_account
    },
    on: {
      "click": function($event) {
        return _vm.$emit('goTo', _vm.index)
      }
    }
  }, [_c('span', {
    staticClass: "font-bold text-2xl mr-1"
  }, [_vm._v(_vm._s(_vm.infoCard.button))]), _vm._v(" "), (_vm.index === 3 || _vm.index === 4 || _vm.index === 5) ? _c('span', {
    staticClass: "absolute top-2"
  }, [_c('i', {
    staticClass: "fas fa-external-link-alt text-xs"
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-ddc5463c!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/support_&_PD/components/supportCard.vue
// module id = 2317
// module chunks = 61